import { Input, Select } from 'antd';
import { __NewTicketFormType } from './newTicket.type';
import CustomUploaderComp from './customUploader/customUploader.index';
import { TicketCategoryData } from 'data';

export const __NewTicketFormData: __NewTicketFormType[] = [
    {
        name: 'title',
        label: 'موضوع اصلی',
        children: <Input placeholder="لطفا موضوع اصلی خود را وارد کنید" />,
        rules: [{ required: true, message: <span>لطفا موضوع اصلی خود را وارد کنید!</span> }],
    },
    {
        name: 'category',
        label: 'انتخاب دسته',
        children: (
            <Select
                options={TicketCategoryData.map((i) => ({ label: i.title, value: i.value }))}
                placeholder="لطفا دسته بندی تیکت را انتخاب کنید"
            />
        ),
        rules: [{ required: true, message: <span>لطفا دسته خود را انتخاب کنید!</span> }],
    },
    {
        name: 'text',
        label: 'توضیحات تیکت',
        children: <Input.TextArea placeholder="توضیحات تیکت خود را بنویسید..." />,
        rules: [{ required: true, message: <span>لطفا توضیحات تیکت خود را وارد کنید!</span> }],
        span: 24,
    },
    {
        name: 'files',
        label: 'بارگذاری فایل',
        children: <CustomUploaderComp />,
    },
];
